import { MediaEdit } from 'components';

export default MediaEdit;
